import { render } from "./RacesEvent.vue?vue&type=template&id=e1815c3c"
import script from "./RacesEvent.vue?vue&type=script&lang=js"
export * from "./RacesEvent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__